import styled from "styled-components";
import { motion } from "framer-motion";

export const AccordionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-content: center;
`;

export const AccordionItem = styled(motion.div)`
  border-radius: 0px;
  overflow: hidden;
  background: #fff;
  border-bottom: 1px solid #595959;
  transition: box-shadow 0.3s ease;
`;

export const AccordionHeader = styled.div`
  padding: 24px 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s ease;
  
  span {
    font-size: 18px;
    font-weight: 600;
    transition: color 0.3s ease;
  }

  @media (max-width: 768px) {
    padding: 20px 24px;
    
    span {
      font-size: 16px;
    }
  }
`;

export const AccordionIcon = styled.div`
  font-size: 24px;
  font-weight: 300;
  color: #555;
  transition: color 0.3s ease, transform 0.3s ease;
  
  ${AccordionHeader}:hover & {
    color: #111;
  }
  
  ${AccordionHeader}[$isActive="true"] & {
    color: #fff;
    transform: rotate(180deg);
  }
`;

export const AccordionContent = styled(motion.div)`
  overflow: hidden;
`;

export const AccordionDescription = styled.div`
  padding: 0 0px 24px;
  color: #555;
  line-height: 1.6;
  font-size: 16px;

  @media (max-width: 768px) {
    padding: 0 24px 20px;
    font-size: 15px;
  }
`;